import { useEffect, useState } from 'react';

interface IUseValoresIndicesOpts {
    reset?: boolean;
    initialValues?: string[];
    /** Preenchido quando `comOpcaoNenhumEmRadioESelect` está ativo, para semear o sentinela nos campos Radio/Select. */
    valorInicialPorIndice?: (index: number) => string | undefined;
    /**
     * Token opcional que, ao mudar, força um novo semeio a partir de `initialValues` —
     * útil quando `rows` não muda (mesmo tipo/índices) mas o valor de origem mudou
     * (ex.: trocou de documento e os valores já preenchidos desse documento chegaram depois).
     */
    initialValuesKey?: string | number;
}

export const useValoresIndices = (rows: unknown[], opts?: IUseValoresIndicesOpts) => {
    const [valores, setValores] = useState<string[]>([]);

    const setValor = (index: number, novoValor: string) => {
        setValores((prevValores) => {
            const novosValores = [...prevValores];
            novosValores[index] = novoValor;
            return novosValores;
        });
    };

    useEffect(() => {
        if (opts?.reset) {
            setValores(Array.from({ length: rows.length }, (_, index) => opts?.valorInicialPorIndice?.(index) ?? ''));
            return;
        }

        if (opts?.initialValues !== undefined) {
            setValores(
                Array.from({ length: rows.length }, (_, index) => opts.initialValues?.[index] ?? opts?.valorInicialPorIndice?.(index) ?? ''),
            );
        }
        // `initialValues` é propositalmente omitido: ele só deve semear o estado quando as próprias
        // linhas (rows) trocam, um reset é pedido, ou `initialValuesKey` muda — não a cada valor
        // digitado pelo usuário.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [opts?.reset, rows, opts?.initialValuesKey]);

    return { valores, setValor, setValores };
};
